export const WIDGET_IMAGE = {
  src: 'https://caterpillar.scene7.com/is/image/Caterpillar/CM20250107-dc586-98c49',
  width: 64,
  height: 64
};
